import { render, staticRenderFns } from "./OtherProfilePage.vue?vue&type=template&id=0629da68&scoped=true"
import script from "./OtherProfilePage.vue?vue&type=script&lang=js"
export * from "./OtherProfilePage.vue?vue&type=script&lang=js"
import style0 from "./OtherProfilePage.vue?vue&type=style&index=0&id=0629da68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629da68",
  null
  
)

export default component.exports